<template>
  <div class="container text-center container_bg">
    <h2 class="pt-6">{{title}}</h2>
    <Step :arr="arr"
          class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <PDFRender :url="url" />
    </div>
    <div class="pay">
      <el-button type="primary"
                 class="mt-3 mb-3"
                 v-if="!isBackHide"
                 @click="handleBack">上一步</el-button>
      <el-button type="primary"
                 class="mt-3 mb-3"
                 :loading="nextLoading"
                 @click="handleNext">已确认，去签订申请书</el-button>
    </div>
  </div>

</template>

<script>
import Step from '../../../../components/CA/Step'
import pdf from '@/components/pdf/pdf'
import store from '../mixins/store'
import { queryModePayment, getEelecSignUrl } from '@/api/comm'

export default {
  data() {
    return {
      arr: [
        { icon: 1, span: '保函样张确认', status: 'finish', time: '' },
        { icon: 2, span: '申请书签订', status: 'active', time: '' },
        { icon: 3, span: '', status: '', time: '' },
      ],
      title: '申请书签订',
      stepType: 1,
      isBackHide: false,
      nextLoading: false,
      paymentType: '',
    }
  },
  mixins: [store],
  components: {
    Step,
    PDFRender: pdf,
  },
  computed: {
    url() {
      return `/zcjf/base/file/download/${this.$route.query.commitmentPdfId}`
    },
  },
  beforeMount() {
    this.clear()
    //查询支付方式
    queryModePayment({
      orderId: this.$route.query.orderId,
    }).then((res) => {
      if (res.data) {
        this.paymentType = res.data
        if (this.paymentType === '0') {
          this.arr[2].span = '订单支付'
        } else {
          this.arr[2].span = '上传电汇底单'
        }
      }
    })
    this.isBackHide = this.$route.query.isBackHide
  },
  methods: {
    handleBack() {
      this.$router.replace({
        path: this.$route.query.backType,
        query: {
          ...this.$route.query,
          orderID: this.$route.query.orderId,
          backType: this.$route.query.lastBackType,
        },
      })
    },
    handleNext() {
      const orderId = this.$route.query.orderId
      this.nextLoading = true

      //获取电子签章url
      getEelecSignUrl({
        orderId: this.$route.query.orderId,
      }).then((res) => {
        if (res.data) {
          this.nextLoading = false
          const resultCode = res.data.resultCode
          if (resultCode === '0') {
            this.$message.error(res.data.result)
          } else {
            //跳转到签章页面
            window.open(res.data.url);
            let title = '电子签章'
      let text =
        '请您在新打开的网上进行电子签章操作，电子签章完成前请不要关闭窗口'
      let buttonText = '已完成电子签章'
      this.$JalertModal(orderId, title, text, buttonText, () => {
        this.$router.push({
          path: '/orderDetail',
          query: {
            order: orderId,
          },
        })
      })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.pay {
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
  /deep/ button {
    padding: auto;
    width: auto;
    font-size: 15px;
  }
}
</style>
